import isArray from 'lodash/isArray';

function toJS (obj, deep) {
  let res = mobx.toJS(obj);
  if (isArray(res) && deep) {
    let rs = [];
    res.forEach((r)=> {
      rs.push(toJS(r));
    })
    return rs;
  }
  return res;
}

export {
  toJS,
}



// WEBPACK FOOTER //
// ./comMobx/util.js